
import React from 'react';
import '../../../../../../styles/info-car.css';
import Comments from './../damages/comments';
import { INSPECTION_STATE_CODE } from '../../../../../../constants/app/inspection';

const InfoCar = ({ use = '', inspection = {}, energy = '', saveCommentsPictures = () => {}, onChangePictures = () => {}, generalComment = '', images = [], saveComment }) => {
    // const commentIsDisabled = (inspection.generalComment === inspection.generalCommentDB || inspection.state.inspectionStatus !== INSPECTION_STATE_CODE.SENT || inspection.state.inspectionStatus !== INSPECTION_STATE_CODE.DERIVE);
    let commentIsDisabled = false;
    if (inspection.generalComment === inspection.generalCommentDB) {
		commentIsDisabled = true;
	} else if (inspection.state.inspectionStatus === INSPECTION_STATE_CODE.SENT) {
			commentIsDisabled = false;
	} else if (inspection.state.inspectionStatus === INSPECTION_STATE_CODE.DERIVE) {
		commentIsDisabled = false;
	}
	else {		
			commentIsDisabled = true;
	}
    return (
        <div className="main-info-car">
        <table>
            <tbody>
                <tr className="gray-background h3 mb10">
                    <td>USO</td>
                </tr>
                <tr>
                    <td className="text-md">{use}</td>
                </tr>
                <tr className="gray-background h3 mb10">
                    <td>ALIMENTACIÓN</td>
                </tr>
                <tr>
                    <td className="text-md">{energy}</td>
                </tr>
            </tbody>
        </table>
        <Comments
                visible={true}
                type='pic'
				handleChange={onChangePictures}
				title='Ingresa los comentarios'
				handleSave={saveComment}
				comments={inspection.generalComment}
			    isDisabled={commentIsDisabled} />
    </div>
    )
}

export default InfoCar;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/pictures/info-car.js